export const address = '0x2314fE36b684B779a00E0aaC8f01fB934Be4A055'
export const abi = [
  {
    inputs: [
      {
        internalType: 'string',
        name: 'abiKey',
        type: 'string'
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes'
      }
    ],
    name: 'recharge',
    outputs: [],
    stateMutability: 'payable',
    type: 'function'
  }
]

// ABI 编码映射
export const abiMap = {
  super_consensus:
    '[{"internalType": "address", "name": "tokenAddress", "type": "address"},{"internalType": "uint256", "name": "amount", "type": "uint256"},{"internalType": "string", "name": "remark", "type": "string"}]',
  game_node:
    '[{"internalType": "uint256", "name": "amount", "type": "uint256"},{"internalType": "string", "name": "remark", "type": "string"}]',
  game_pledge:
    '[{"internalType": "uint256", "name": "amount", "type": "uint256"},{"internalType": "string", "name": "remark", "type": "string"}]',
  recharge:
    '[{"internalType": "address", "name": "tokenAddress", "type": "address"},{"internalType": "uint256", "name": "amount", "type": "uint256"},{"internalType": "string", "name": "remark", "type": "string"}]',
  peer_receive:
    '[{"internalType": "address", "name": "tokenAddress", "type": "address"},{"internalType": "uint256", "name": "amount", "type": "uint256"},{"internalType": "string", "name": "remark", "type": "string"}]'
}
